import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Lock, User, Users, BookOpen, Clipboard, BarChart, Settings, CreditCard, Gift } from "react-feather";
import man from "../../../assets/images/blank_profile.png";
import { FormLabel, Modal, Row } from "react-bootstrap";
import { Button, Label } from "reactstrap";
import { LI, UL, P } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";
import PrivilegeContext from "../../../_helper/PrivilegeContext";
import { useClinicAdmin } from "../../../_helper/ClinicProvider";
// import { useSocket } from "../../../_helper/SocketProvider";
import { useLoader } from './../../../_helper/LoaderContext';
import axiosInstance from "../../../interceptor/intercetptor-inctence";
import { usePharmacy } from "../../../_helper/PharmacyProvider";
import S3ImageLoader from "../../../S3ImageLoader";
import { useCurrency } from "../../../_helper/CurrencyContext";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLicense } from "../../../_helper/license/LicenseContext";
import { updatePharmacyPOSAfterLicenseUpgrade } from "../../../utils/common";
import fallBackImg from "../../../assets/images/logo/logo.png"
import localforage from 'localforage';
import { getStaffShiftHistory } from "../../../Components/ManageStaff/service/manage-staff-service";

const UserHeader = () => {
  const history = useNavigate();
  const [name, setName] = useState("Pharmacy POS");
  const { getCurrencySymbol, allowedCurrencies } = useCurrency();
  const { saveLicenseToken } = useLicense();

  const { t } = useTranslation()
  const { setLoading } = useLoader();
  const imageBaseURL = process.env.REACT_APP_BASE_URL;
  const { setUserPrivileges } = useContext(PrivilegeContext);
  const { clinicAdmin, setClinicAdmin } = useClinicAdmin();
  const { pharmacyPOS, setPharmacyPOS } = usePharmacy();
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const { clearLicense, decodeTokenOnly } = useLicense();

  const [showClosingAmountModal, setShowClosingAmountModal] = useState(false);
  // const socket = useSocket();
  const [closingAmtForm, setClosingAmtForm] = useState({});
  const [showUpgradePlan, setShowUpgradePlan] = useState(false);
  const [licenseKey, setLicenseKey] = useState('');
  const [error, setError] = useState("")
  const [collectionAmount, setCollectionAmount] = useState({});

  const isAdmin = pharmacyPOS?.isAdmin === true || pharmacyPOS?.role === 'admin';
  const pharmacyLogo = process.env.REACT_APP_IMAGE + pharmacyPOS.logo

  // Initialize closingAmtForm with allowed currencies
  useEffect(() => {
    if (allowedCurrencies?.length > 0) {
      const initialForm = {};
      allowedCurrencies.forEach(currency => {
        // Get current wallet balance or set to empty string
        const currentBalance = pharmacyPOS?.wallets?.[currency] || "0";
        initialForm[currency] = "";
      });
      setClosingAmtForm(initialForm);
    }
    getCollectionAmount();
    decodeTokenOnly().then((result) => {
      setSubscriptionInfo(result);
    })
  }, [allowedCurrencies, pharmacyPOS?.wallets]);

  const logoutUserOld = async () => {
    try {
      setLoading(true);
      const body = {
        closingAmount: {

        }
      }
      const response = await axiosInstance.post(`/pharma/healthcare_providers/auth/logou`);
      if (response.data.status === "success") {
        // Logout();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const logoutUserWithClosing = async () => {
    getCollectionAmount();
    // First show the modal for user to enter closing amounts
    setShowClosingAmountModal(true);
  };

  const handleConfirmLogout = async () => {
    try {
      setLoading(true);

      // 1. Validate closing amounts
      const closingAmount = {};
      let isValid = true;
      const validationErrors = {};

      allowedCurrencies.forEach(currency => {
        const value = closingAmtForm[currency]?.trim();

        // Validation: must be a valid number and >= 0
        if (value === "" || isNaN(value) || parseFloat(value) < 0) {
          validationErrors[currency] = t("Please enter a valid amount");
          isValid = false;
        }

        // Convert to number for API
        closingAmount[currency] = parseFloat(value) || 0;
      });

      if (!isValid) {
        toast.warning(t("Please enter valid closing amounts for all currencies"));
        setLoading(false);
        return;
      }

      // 2. Build request body with dynamic currencies
      const body = {
        closingAmount
      };

      console.log("Logout request body:", body);

      // 3. Call logout API with closing amounts
      const response = await axiosInstance.post(
        `/healthcare_providers/auth/logout`,
        body
      );

      if (response?.data?.status === "success") {
        // 4. Close modal and logout user
        setShowClosingAmountModal(false);
        logoutUser();

        // Show success message
        toast.success(t("Logout successful with closing amount recorded"));
      } else {
        toast.warning(response?.data?.message || t("Logout failed"));
      }
    } catch (error) {
      console.error("Logout API error:", error);
      toast.warning(t("Something went wrong. Please try again."));
    } finally {
      setLoading(false);
    }
  };


  const logoutUser = async () => {
    setUserPrivileges(null);
    localStorage.removeItem("profileURL");
    localStorage.removeItem("pharmacyPOSAuth");
    localStorage.removeItem("currentPharmacyPOS");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    await clearLicense()
    // socket.emit('userLogout', { userId: clinicAdmin._id, userRole: clinicAdmin.role })
    // socket.disconnect();
    // setClinicAdmin(null);
    setPharmacyPOS(null);
    history(`${process.env.PUBLIC_URL}/login`, { replace: true });
  };

  const changePassword = () => {
    history(`${process.env.PUBLIC_URL}/change-password`);
  };
  const updateProfile = () => {
    history(`${process.env.PUBLIC_URL}/update-profile`);
    // history(`${process.env.PUBLIC_URL}/profile`);
  };

  const gotoGstDiary = () => {
    history(`${process.env.PUBLIC_URL}/gst-diary`);
    // history(`${process.env.PUBLIC_URL}/profile`);
  };

  const gotoSettings = () => {
    history(`${process.env.PUBLIC_URL}/manage-settings`);
    // history(`${process.env.PUBLIC_URL}/profile`);
  };

  const OpenUpdatePlanModal = () => {
    setLicenseKey("")
    setShowUpgradePlan(true);
  }

  const handleUpdate = async () => {
    if (licenseKey === "") {
      setError("Please enter license key")
      return
    }
    if (pharmacyPOS.licenseKey === licenseKey.trim()) {
      setError("")
      Swal.fire({
        icon: 'info',
        text: "Please Enter new license key"
      })
    } else {
      setError("")
      Swal.fire({
        icon: 'info',
        title: "Are you sure?",
        text: 'Changing your plan may impact available features and limits. Please confirm to proceed.',
        showCancelButton: true,
        confirmButtonText: "Yes, Upgrade",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          try {
            // const form_data = new FormData();
            // form_data.append("licenseKey", licenseKey)
            const payload = {
              // oldLicenseKey: pharmacyPOS.licenseKey,
              licenseKey,
              // user: {
              //   id: pharmacyPOS._id,
              //   name: pharmacyPOS.contact_person.first_name + " " + pharmacyPOS.contact_person.last_name,
              // }
            }
            const response = await axiosInstance.post('healthcare_providers/auth/updateLicensePlan', payload)

            // const res = await upgradePlan(payload)
            if (response.data.status === "success") {
              toast.success(response.data.message);
              const licenseData = response.data.data.data;
              // 1️⃣ Save new license token (LicenseContext / localforage)
              await saveLicenseToken(licenseData.token);
              // 2️⃣ Merge updated plan & license into pharmacyPOS
              const updatedPharmacyPOS = updatePharmacyPOSAfterLicenseUpgrade(
                pharmacyPOS,
                licenseData
              );

              // 3️⃣ Update Context
              setPharmacyPOS(updatedPharmacyPOS);
              // 4️⃣ Persist to localStorage
              localStorage.setItem(
                "currentPharmacyPOS",
                JSON.stringify(updatedPharmacyPOS)
              );

              // 5️⃣ UI cleanup
              setLicenseKey("");
              setShowUpgradePlan(false);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          } catch (error) {
            console.log(error)
          } finally {
            setLoading(false)
          }
        } else {
          setLicenseKey("")
          setShowUpgradePlan(false);
        }
      })
    }
  };


  const handleWalletInput = (e) => {
    const { name, value } = e.target;
    setClosingAmtForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getCurrentWalletBalance = (currency) => {
    const currentBalance = pharmacyPOS?.wallets?.[currency] || 0;
    return currentBalance.toFixed(2)
  };

  const ViewPackageDetails = () => {
    history(`${process.env.PUBLIC_URL}/package-details`);
  }


  const getCollectionAmount = async () => {
    const body = {
      cashierId: pharmacyPOS._id,
      status: "running",
    };

    try {
      const response = await getStaffShiftHistory(body);

      if (response.data.status === "success") {
        const shift =
          response.data.data?.pharmacyUserList?.[0];

        setCollectionAmount(
          shift?.totalSalesSystemCalculatedAmount || {}
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <li className="py-0 profile-nav onhover-dropdown pe-0">
        <div className="media profile-media" style={{ alignItems: 'center' }}>
          <S3ImageLoader
            className="m-0 b-r-10"
            fileName={pharmacyPOS?.logo}
            style={{ height: '32px', width: '32px', objectFit: 'cover' }}
            alt="profile"
            fallbackSrc={man}
          />
          {/* <div className="pharmacy-logo">
            <img
              src={pharmacyLogo}
              alt="Pharmacy Logo"
              onError={(e) => (e.target.src = fallBackImg)}
            />
          </div> */}
          {/* src: `${authenticated ? clinicAdmin?.picture : profile}`, */}
          <div className="media-body">
            {/* <span>{authenticated ? clinicAdmin?.name : name}</span> */}
            <span>{pharmacyPOS?.facility_name || name}</span>
            {/* <P attrPara={{ className: "mb-0 font-roboto" }}>
            {clinicAdmin?.role === 'clinic_admin' ? (
              <span>{t("Clinic Admin")}</span>
            ) : clinicAdmin?.role === "sub admin" ? (
              "Sub Admin"
            ) : clinicAdmin?.role === "staff" ? (
              "Staff"
            ) : clinicAdmin?.role === "accountant" ? (
              "Accountant"
            ) : (
              "Sub Admin"
            )}
          </P> */}
          </div>
        </div>
        <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
          <LI attrLI={{ onClick: updateProfile }}>
            <User />
            <span>{t("profile")}</span>
          </LI>
          {isAdmin && (
            <>
              <LI attrLI={{ onClick: OpenUpdatePlanModal }}>
                <CreditCard size={18} />
                <span>{t("Upgrade Plan")}</span>
              </LI>
              <LI attrLI={{ onClick: ViewPackageDetails }}>
                <Gift size={18} />
                <span>{t("Package Benefits")}</span>
              </LI>
              <LI attrLI={{ onClick: gotoGstDiary }}>
                <BarChart size={18} />
                <span>{t("GST Diary")}</span>
              </LI>
              <LI attrLI={{ onClick: gotoSettings }}>
                <Settings size={18} />
                <span>{t("Setting")}</span>
              </LI>
            </>
          )}
          {/* <LI attrLI={{ onClick: ViewPackageDetails }}>
            <Gift size={18} />
            <span>{t("Package Benefits")}</span>
          </LI> */}
          <LI attrLI={{ onClick: changePassword }}>
            <Lock />
            <span>{t("changePassword")}</span>
          </LI>
          <LI attrLI={{ onClick: logoutUserWithClosing }}>
            <LogIn />
            <span>{t("logOut")}</span>
          </LI>
        </UL>
      </li>

      <Modal show={showClosingAmountModal} onHide={() => setShowClosingAmountModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("Closing Amount Record Entry")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <p className="small mb-0">
              {t("Please enter the closing amount for each currency manually. Current balances are shown for reference.")}
            </p>
          </div>

          {allowedCurrencies?.length > 0 ? (
            allowedCurrencies.map((currency) => (
              <div key={currency} className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label mb-0">
                    {getCurrencySymbol(currency)} ({currency})
                  </label>
                  <div className="d-flex align-items-center gap-2">
                    <small className="text-muted">
                      {t("Current balance")}:
                    </small>
                    <small className="fw-semibold">
                      {getCurrencySymbol(currency)} {collectionAmount[currency]?.toFixed(2) || "0.00"}
                    </small>
                  </div>
                </div>
                <div className="input-group">
                  <span className="input-group-text border-end-0">
                    {getCurrencySymbol(currency)}
                  </span>
                  <input
                    name={currency}
                    className="form-control border-start-0"
                    value={closingAmtForm[currency] || ""}
                    onChange={handleWalletInput}
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder={t("Enter closing amount")}
                    required
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4">
              <p className="text-muted">{t("No currencies configured")}</p>
            </div>
          )}

          {/* Summary section */}
          {/* {allowedCurrencies?.length > 0 && (
            <div className="mt-4 pt-3 border-top">
              <div className="row">
                <div className="col-6">
                  <small className="text-muted">{t("Total currencies")}:</small>
                  <div className="fw-semibold">{allowedCurrencies.length}</div>
                </div>
                <div className="col-6 text-end">
                  <small className="text-muted">{t("All fields are required")}</small>
                </div>
              </div>
            </div>
          )} */}
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="primary"
            onClick={handleConfirmLogout}
            disabled={!allowedCurrencies || allowedCurrencies.length === 0}
          >
            {t("Confirm & Logout")}
          </Button>
          <Button
            color="secondary"
            onClick={logoutUser}
            className="me-2"
          >
            {t("Logout Direct")}
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowClosingAmountModal(false)}
            className="me-2"
          >
            {t("Cancel")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showUpgradePlan} onHide={() => setShowUpgradePlan(false)} centered>
        <Modal.Header>
          <Modal.Title>Upgrade Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">Current License Key: <span className='tw-font-bold'>{subscriptionInfo?.license.key}</span></div>
          <div className="form-group mt-2">
            <Label>New License Key</Label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter new license key"
              value={licenseKey}
              onChange={(e) => setLicenseKey(e.target.value)}
            />
            <span className="tw-text-red-500">{error}</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button color="primary" onClick={handleUpdate}>
            Upgrade
          </Button>
          <Button color="secondary" onClick={() => setShowUpgradePlan(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserHeader;
